<template>
  <!-- App访问日志 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <!-- 操作日期 -->
        <el-form-item :label="$t('pages.research.text11')">
          <el-date-picker
            v-model="startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            @change="startChange"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
          <span style="margin: 0 8px">-</span>
          <el-date-picker
            v-model="stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 平台方 -->
        <el-form-item :label="$t('menu.platform')">
          <el-select
            v-model="searchParams.belongCustomer"
            clearable
            :placeholder="$t('pages.research.text89')"
          >
            <el-option
              v-for="(item, index) in option"
              :key="index"
              :label="item.platformShortName"
              :value="item.id + ''"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 操作人 -->
        <el-form-item :label="$t('pages.research.text14')">
          <el-input
            v-model="searchParams.appAccount"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <!-- 请求地址 -->
        <el-form-item :label="$t('omission.text37')">
          <el-autocomplete
            class="inline-input"
            clearable
            v-model="searchParams.requestUrl"
            :fetch-suggestions="querySearch"
            :placeholder="$t('public.text1')"
            :trigger-on-focus="true"
            @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>
        <!-- 参数内容 -->
        <el-form-item label="参数内容">
          <el-input
            v-model="searchParams.contentLike"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 按钮区域 -->
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['logList:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['logList:reset']"
        ></DiluButton>
      </div>
    </div>
    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      :total="total"
      @currentChange="currentChange"
    >
      <el-table-column prop="date" label="#" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <!-- 操作人账号 -->
      <el-table-column
        prop="appAcount"
        :label="$t('pages.research.text15')"
        align="left"
      >
      </el-table-column>
      <!-- requestUrl -->
      <el-table-column
        prop="requestUrl"
        width="400"
        label="RequestUrl"
        align="left"
      >
      </el-table-column>
      <!-- IP -->
      <el-table-column prop="requestIp" label="IP" align="center">
      </el-table-column>
      <!-- 操作日期 -->
      <el-table-column
        prop="createdAt"
        :label="$t('pages.research.text11')"
        align="center"
      >
      </el-table-column>
      <!-- 操作 -->
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="details(scope.row)" type="text">{{
              $t("omission.text35")
            }}</el-button>
            <el-button @click="see(scope.row)" type="text">{{
              $t("omission.text73")
            }}</el-button>
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 请求参数弹窗 -->
    <el-dialog
      :title="$t('omission.text35')"
      :visible.sync="dialogVisible"
      width="600px"
      padding-top="10px"
    >
      <RequestParam :json="jsonData" />
    </el-dialog>
  </div>
</template>

<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import { resetDate } from "../../../utils/util/validate";
import RequestParam from "../../system/operationLog/module/RequestParam.vue";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));

              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      //选中的开始日期之前的日期禁选
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));

              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      searchParams: {
        belongCustomer: "", // 归属客户
        compare: "", // 比较条件
        createdAt: "", // 操作日期
        duration: "", // 执行时长
        pageNum: 1, // 页码
        pageSize: 10, // 每页条数
        contentLike: "", //参数内容
        appAccount: "", // 操作人账号
        requestUrl: "", // 请求地址
      },
      dialogVisible: false, //详情弹窗状态
      startAt: "", //开始日期
      stopAt: "", //结束日期
      total: 0,
      option: [], //平台方
      tableConfig: {
        isTree: false,
        isPage: true, //打开分页功能
      },
      jsonData: {}, //请求参数
      tableData: [],
      restaurants: [],
      searchcuslist: [],
    };
  },
  components: {
    DiluTable,
    DiluButton,
    RequestParam,
  },
  created() {
    this.queryAppRequestUrl(); //APP接口数据
  },
  mounted() {
    this.stopAt = resetDate(new Date()); // 当前时间
    this.startAt = this.fun_date(-7); //七天前的时间
    this.appLogList();
    this.platformListAll();
  },
  methods: {
    //获取所有App接口
    queryAppRequestUrl() {
      let str = "";
      this.request.queryAppRequestUrl(str).then((res) => {
        const that = this;
        this.curricululists = res.data;
        res.data.forEach((v) => {
          // 下拉框值进行赋值
          that.searchcuslist.push({ value: v });
        });
        this.restaurants = this.loadAll();
      });
    },
    //根据输入值筛选App接口数据
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !=
          -1
        );
      };
    },
    // 请求参数
    details(e) {
      if (e.requestParam == "" || e.requestParam == "{}") {
        this.jsonData = [this.$t("omission.text36")];
      } else {
        let json = JSON.parse(e.requestParam);
        //let list = JSON.parse(json.statusList);
        this.jsonData = json;
        console.log(json);
      }
      this.dialogVisible = true;
    },
    see(e) {
      if (e.userAgent == "" || e.userAgent == "{}") {
        this.jsonData = [this.$t("omission.text36")];
      } else {
        this.jsonData = JSON.parse(e.userAgent);
      }
      this.dialogVisible = true;
    },
    //返回App接口数据
    loadAll() {
      var that = this;
      return that.searchcuslist;
    },
    //选中请求地址输入框中文字
    handleSelect(item) {
      console.log(item);
    },
    //搜索
    search() {
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.appLogList();
    },
    //更改开始日期时间时结束日期时间置空重选
    startChange() {
      this.stopAt = "";
    },
    //平台方-查询所有
    platformListAll() {
      this.request.platformListAll().then((res) => {
        this.option = res.data;
      });
    },
    // 翻页
    currentChange(e) {
      this.searchParams.pageNum = e;
      this.appLogList();
    },
    // 重置
    reset() {
      this.searchParams = {
        belongCustomer: "", // 归属客户
        apiName: "", // 日志类别
        compare: "", // 比较条件
        createdAt: "", // 操作日期
        duration: "", // 执行时长
        pageNum: 1, // 页码
        pageSize: 10, // 每页条数
        contentLike: "",
        realName: "", // 操作人
        requestUrl: "", // 请求地址
      };
      this.total = 0;
      this.startAt = ""; //开始日期
      this.stopAt = ""; //结束日期
      this.appLogList();
    },
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    // 获取当前时间
    fun_date(aa) {
      var date1 = new Date();
      var date2 = new Date(date1);
      var hour = date2.getHours();
      var minute = date2.getMinutes();
      var second = date2.getSeconds();
      // 获取当前时间前后aa天时间
      date2.setDate(date1.getDate() + aa);
      var time2 =
        date2.getFullYear() +
        "-" +
        (date2.getMonth() + 1) +
        "-" +
        date2.getDate() +
        " " +
        this.formatTen(hour) +
        ":" +
        this.formatTen(minute) +
        ":" +
        this.formatTen(second);
      return time2;
    },
    // 获取日志列表
    appLogList() {
      if (this.stopAt && this.startAt) {
        this.stopAt = resetDate(this.stopAt); // 结束时间
        this.startAt = resetDate(this.startAt); // 开始时间
        this.searchParams.createdAt = [this.startAt, this.stopAt];
      } else {
        this.searchParams.createdAt = [];
      }
      if (this.startAt) {
        if (!this.stopAt) {
          return this.$message.error(this.$t("public.text3")); //请选择结束日期
        }
      }
      if (this.stopAt) {
        if (!this.startAt) {
          return this.$message.error(this.$t("public.text2")); //请选择开始日期
        }
      }
      this.request.appLogList(this.searchParams).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.dataMaxCount;
      });
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
.inline-input {
  width: 463px;
}
</style>